export default __webpack_public_path__ + "static/media/logo-verification.c5726da1.png";